<div>
	<div class="header">
		<div class="title" *ngIf="title">
			<h3>{{title}}</h3>
		</div>
		<form [formGroup]="inputDateForm">
			<div class="filter-grid">
				<!-- Created Date From -->
				<mat-form-field appearance="outline">
					<mat-label>From</mat-label>
					<input matInput [matDatepicker]="fromPicker" formControlName="dateFrom"
						placeholder="Select date">
					<mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
					<mat-datepicker #fromPicker></mat-datepicker>
				</mat-form-field>

				<!-- Created Date To -->
				<mat-form-field appearance="outline">
					<mat-label>To</mat-label>
					<input matInput [matDatepicker]="toPicker" formControlName="dateTo"
						placeholder="Select date">
					<mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
					<mat-datepicker #toPicker></mat-datepicker>
				</mat-form-field>
				<button mat-raised-button color="primary" (click)="getBalance()">Submit</button>
			</div>
		</form>
	</div>
	<div>
		<table class="styled-table">
			<caption>Loan Movement</caption>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th>S1 Low</th>
					<th>S1 Normal</th>
					<th>S2 Normal</th>
					<th>S2 High</th>
					<th>S3 Normal</th>
					<th>S3 High</th>
					<th>Writen off</th>
					<th>Total</th>
					<th>Base PD</th>
					<th>PD marco Overlay</th>
					<th>Adjusted PD</th>
					<th>LGD</th>
					<th>Weighted LGD</th>
					<th>Adjusted LGD</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>S1 Low</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage1.low, 'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.low.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(balance.stage1.low.total,
							'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.low.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage1.low.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.low.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.low.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage1.low.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.low.adjusted_lgd)}}
						</div>
					</td>
				</tr>
				<tr>
					<td>S1 Normal</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage1.low, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage1.normal.total, 'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.normal.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage1.normal.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.normal.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.normal.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage1.normal.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage1.normal.adjusted_lgd)}}
						</div>
					</td>
				</tr>
				<tr>
					<td>S2 Normal</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage1.low, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.normal.total, 'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.normal.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage2.normal.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.normal.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.normal.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage2.normal.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.normal.adjusted_lgd)}}
						</div>
					</td>
				</tr>
				<tr>
					<td>S2 High</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage1.low, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage2.high.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(balance.stage2.high.total,
							'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.high.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage2.high.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.high.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.high.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage2.high.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage2.high.adjusted_lgd)}}
						</div>
					</td>
				</tr>
				<tr>
					<td>S3 Normal</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage1.low, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.normal.total, 'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.normal.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage3.normal.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.normal.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.normal.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage3.normal.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.normal.adjusted_lgd)}}
						</div>
					</td>
				</tr>
				<tr>
					<td>S3 High</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage1.low, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage1.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage2.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage2.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage3.normal, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage3.high, 'CAD', 'symbol-narrow')}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">
							{{currencyFormatter.transform(balance.stage3.high.stage4["Writen off"], 'CAD',
							'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{currencyFormatter.transform(balance.stage3.high.total,
							'CAD', 'symbol-narrow')}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.high.base_pd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage3.high.pd_macro_overlay}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.high.adjusted_pd)}}
						</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.high.lgd)}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{balance.stage3.high.weighted_lgd}}</div>
					</td>
					<td>
						<div *ngIf="!isLoading; else skeleton">{{formatter.format(balance.stage3.high.adjusted_lgd)}}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>

	<!-- Reusable Skeleton Templates -->
	<ng-template #skeleton>
		<ngx-skeleton-loader count="1" appearance="line"
			[theme]="{ height: '20px', width: '80px', margin: '0' }"></ngx-skeleton-loader>
	</ng-template>
</div>